import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 h-full xl:h-screen w-full pt-6 xl:pt-[88px] pb-6 px-4" }
const _hoisted_2 = { class: "relative items-center md:hidden" }
const _hoisted_3 = { class: "absolute left-0" }
const _hoisted_4 = { class: "text-2xl font-medium leading-[32px] text-brown" }
const _hoisted_5 = { class: "text-left md:mx-auto py-6 px-4 md:px-10 bg-white rounded-[20px] flex flex-col items-center w-full md:max-w-[812px] h-full min-h-0 overflow-y-auto no-scrollbar" }
const _hoisted_6 = { class: "relative hidden md:flex justify-center items-center w-full min-h-11 mb-2 px-10" }
const _hoisted_7 = { class: "absolute left-0" }
const _hoisted_8 = { class: "mx-auto text-2xl font-semibold leading-[32px] text-brown" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm font-normal leading-[20px] text-muted italic mb-10"
}
const _hoisted_10 = {
  key: 1,
  class: "font-normal text-base leading-[20px] text-black w-full mb-4"
}
const _hoisted_11 = ["placeholder"]

import PredictionResult from "@/views/Calculators/TarotPrediction/SituationPrediction/components/PredictionResult.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { ref } from "vue";
import { TarotSituationPredictionResponse } from "@/types/calculators";
import { fetchTarotSituationPrediction } from "@/api/calculators";
import { useSafeBack } from "@/utils/useSafeBack";
import BackButton from "@/components/buttons/BackButton.vue";
import { useI18n } from "vue-i18n";
import GradientButton from "@/components/buttons/GradientButton.vue";
import PredictionInstruction from "@/views/Calculators/TarotPrediction/SituationPrediction/components/PredictionInstruction.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TarotSituationPrediction',
  setup(__props) {

const { t } = useI18n();
const { safeBack } = useSafeBack();

const requestedSituation = ref<string>("");
const loading = ref<boolean>(false);
const predictionResult = ref<TarotSituationPredictionResponse | null>(null);

async function getSituationPrediction(situation: string) {
  loading.value = true;
  requestedSituation.value = situation;
  try {
    predictionResult.value = await fetchTarotSituationPrediction(situation);
  } finally {
    loading.value = false;
  }
}

function handleBack() {
  if (predictionResult.value) {
    predictionResult.value = null;
    return;
  }
  safeBack(ROUTE_NAMES.TAROT);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BackButton, { onClicked: handleBack })
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("calculators.tarot.situation-prediction.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BackButton, { onClicked: handleBack })
        ]),
        _createElementVNode("h2", _hoisted_8, _toDisplayString(predictionResult.value
              ? _unref(t)("calculators.tarot.situation-prediction.result-title")
              : _unref(t)("calculators.tarot.situation-prediction.title")), 1)
      ]),
      (!predictionResult.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)("calculators.tarot.situation-prediction.short-tip")), 1))
        : _createCommentVNode("", true),
      (!predictionResult.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)("calculators.tarot.situation-prediction.input-label")), 1))
        : _createCommentVNode("", true),
      (!predictionResult.value)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 2,
            class: "rounded-[20px] border border-muted w-full min-h-28 mb-10 p-4 resize-none focus:outline-none focus:ring-0 focus:border-muted",
            placeholder: 
          _unref(t)('calculators.tarot.situation-prediction.input-placeholder')
        
          }, null, 8, _hoisted_11))
        : _createCommentVNode("", true),
      (!predictionResult.value)
        ? (_openBlock(), _createBlock(GradientButton, {
            key: 3,
            class: "w-[353px] min-h-14 mb-10 hidden md:flex",
            "bg-color": "bg-brown-gradient",
            "hover-bg-color": "bg-orange-gradient",
            text: _unref(t)('calculators.tarot.situation-prediction.get-prediction-btn'),
            onClick: getSituationPrediction,
            "is-loading": loading.value
          }, null, 8, ["text", "is-loading"]))
        : _createCommentVNode("", true),
      (!predictionResult.value)
        ? (_openBlock(), _createBlock(GradientButton, {
            key: 4,
            class: "w-[247px] min-h-14 mb-10 md:hidden",
            "bg-color": "bg-brown-gradient",
            "hover-bg-color": "bg-orange-gradient",
            text: 
          _unref(t)('calculators.tarot.situation-prediction.get-prediction-btn-short')
        ,
            onClick: getSituationPrediction,
            "is-loading": loading.value
          }, null, 8, ["text", "is-loading"]))
        : (_openBlock(), _createBlock(PredictionResult, {
            key: 5,
            result: predictionResult.value
          }, null, 8, ["result"])),
      (!predictionResult.value)
        ? (_openBlock(), _createBlock(PredictionInstruction, { key: 6 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})